module.exports = __webpack_public_path__ + "img/Monte_Kope_60.9e37850c.jpg";